"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodeEditor = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = _interopRequireDefault(require("@monaco-editor/react"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var _WYSIWYG = require("./WYSIWYG");
var _registerWidgetForDnD = require("../styles/registerWidgetForDnD");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var LANGUAGES = {
  html: "html",
  json: "json"
};
var EDITOR_CHANGE_DELAY = 250;
var CodeEditor = function CodeEditor(props) {
  var value = props.value || props.defaultValue || "";
  var _props$theme = props.theme,
    theme = _props$theme === void 0 ? "vs-dark" : _props$theme,
    _props$size = props.size,
    size = _props$size === void 0 ? "normal" : _props$size;
  var _useState = (0, _react.useState)(value),
    _useState2 = _slicedToArray(_useState, 2),
    editorValue = _useState2[0],
    setEditorValue = _useState2[1];
  var editorRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var handleEditorDidMount = function handleEditorDidMount(editor, monaco) {
    editorRef.current = editor;
  };
  var handleEditorChange = function handleEditorChange() {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    setEditorValue(val);
    if (props.onChange && inputRef.current) {
      inputRef.current.value = val;
      var _e2 = {};
      _e2.target = inputRef.current;
      _e2.currentTarget = inputRef.current;
      props.onChange(_e2);
    }
  };
  var handleEditorChangeDebounced = (0, _react.useMemo)(function () {
    return (0, _debounce.default)(function (val, e) {
      return handleEditorChange(val, e);
    }, EDITOR_CHANGE_DELAY);
  }, [props.onChange]);
  var editorProps = size === "mini" ? {
    options: {
      tabSize: 2,
      minimap: {
        enabled: false
      }
    }
  } : {};
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: props.height || "100%",
      width: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement(_react2.default, _extends({}, editorProps, {
    theme: theme,
    height: props.height || "100%",
    defaultLanguage: LANGUAGES[props.language] || props.language,
    defaultValue: editorValue,
    onChange: handleEditorChangeDebounced,
    onMount: handleEditorDidMount
  })), /*#__PURE__*/_react.default.createElement("input", {
    type: "hidden",
    ref: inputRef,
    value: editorValue,
    name: props.name
  }));
};
exports.CodeEditor = CodeEditor;
(0, _registerWidgetForDnD.registerKuiWidget)({
  name: "HTML",
  component: function component(props) {
    return /*#__PURE__*/_react.default.createElement(_WYSIWYG.WYSIWYGView, props);
  },
  options: {
    value: "html"
  },
  icon: "code_blocks"
});